module.exports = __webpack_public_path__ + "img/187.824c5bca.jpg";